import { useEffect } from "react";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";

const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "AccountingService",
      "@id": `${siteUrl}/#business`,
      "name": "MTC Associates",
      "url": siteUrl,
      "logo": {
        "@type": "ImageObject",
        "url": "https://storage.readdy-site.link/project_files/01f647ac-7c86-4957-a691-a312488d1835/b834e0b9-5147-41e6-9283-ddaf681edf2e_Gemini_Generated_Image_we2h8lwe2h8lwe2h.png?v=7910b91963806043e5a40ee3ce67ff55",
        "caption": "MTC Associates Logo"
      },
      "image": "https://storage.readdy-site.link/project_files/01f647ac-7c86-4957-a691-a312488d1835/b834e0b9-5147-41e6-9283-ddaf681edf2e_Gemini_Generated_Image_we2h8lwe2h8lwe2h.png?v=7910b91963806043e5a40ee3ce67ff55",
      "description": "MTC Associates provides professional accounting, bookkeeping, and tax services in Miami, FL. Trusted by 500+ businesses and individuals since 2010. Remote-friendly and serving clients nationwide.",
      "telephone": ["+17864612818", "+13057332170"],
      "email": "admin@mtcassociate.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Miami",
        "addressRegion": "FL",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 25.7617,
        "longitude": -80.1918
      },
      "areaServed": {
        "@type": "Country",
        "name": "United States"
      },
      "foundingDate": "2010",
      "priceRange": "$$",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "17:00"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Accounting & Bookkeeping Services",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bookkeeping Services" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "QuickBooks Setup & Cleanup" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Financial Statements" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Payroll Processing" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Sales Tax Filing" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Financial Advisory" } }
        ]
      }
    },
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "url": siteUrl,
      "name": "MTC Associates",
      "description": "Professional accounting, bookkeeping, and tax services in Miami, FL.",
      "publisher": {
        "@id": `${siteUrl}/#business`
      },
      "inLanguage": "en-US"
    },
    {
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      "url": siteUrl,
      "name": "MTC Associates Miami Accounting, Bookkeeping & Tax Services",
      "isPartOf": { "@id": `${siteUrl}/#website` },
      "about": { "@id": `${siteUrl}/#business` },
      "description": "MTC Associates provides expert accounting, bookkeeping & tax services in Miami, FL. Trusted by 500+ businesses & individuals since 2010.",
      "inLanguage": "en-US",
      "dateModified": "2026-04-02"
    }
  ]
};

export default function SEOSchema() {
  useEffect(() => {
    const existing = document.getElementById("schema-org-mtc");
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-org-mtc";
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById("schema-org-mtc");
      if (el) el.remove();
    };
  }, []);

  return null;
}
